import { requirePermissionBeforeLoad } from '@/shared/lib/authorization/routeAuth'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/categories/')({
    beforeLoad: ({ location }) => {
        requirePermissionBeforeLoad('view', 'system')
        const pathname = location.pathname
        if (pathname === '/categories') {
            throw redirect({ to: '/categories/departments' })
        }
    },
})
